var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"lw-toolbar",class:{
    'align-center': _vm.align === 'center',
    'align-right': _vm.align === 'right',
    'fixed': _vm.toolbarFixed
  },style:(_vm.fixedToolbarStyle)},_vm._l((_vm.childGroup),function(child,index){return _c(child.is,{key:index,tag:"component",staticClass:"lw-toolbar-item",attrs:{"component":child}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }